export function formatDisplayAddress(address) {
  if (!address || typeof address !== 'string') return '';
  const stripped = address.replace(
    /,\s*(schweiz|switzerland|suisse|svizzera|ch)\s*\.?\s*$/i,
    ''
  );
  return stripped.replace(/[,\s]+$/, '').trim();
}
